import { render, staticRenderFns } from "./report-suggest.vue?vue&type=template&id=deb2e316&scoped=true"
import script from "./report-suggest.vue?vue&type=script&lang=ts"
export * from "./report-suggest.vue?vue&type=script&lang=ts"
import style0 from "./report-suggest.vue?vue&type=style&index=0&id=deb2e316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb2e316",
  null
  
)

export default component.exports